import { Map } from 'immutable'
import _ from 'lodash'

import {
    FINANCE_TABLE_SET_YEAR_BOUNDS,
    FINANCE_TABLE_CHANGE_YEAR_BOUNDS,
    FINANCE_TABLE_SET_YEARS,
    FINANCE_TABLE_CHANGE_COMPARE_YEAR,
    FINANCE_TABLE_CHANGE_SAMPLE_YEAR,
    FINANCE_TABLE_ADD_OPEN_ROW,
    FINANCE_TABLE_REMOVE_OPEN_ROWS,
    FINANCE_TABLE_SET_OPEN_ROWS,
} from './constants'
import { CLOSE_REPORT_BY_ID } from '../../scenes/Gnosus/scenes/Report/constants'

const initialState = Map({})

export default function financeReducer(state = initialState, action = {}) {
    switch (action.type) {
        case FINANCE_TABLE_SET_YEAR_BOUNDS: {
            const id = _.get(action, 'data.id', null)
            const tableType = _.get(action, 'data.tableType', null)
            const lowerBound = _.get(action, 'data.lowerBound', null)
            const upperBound = _.get(action, 'data.upperBound', null)

            if (!id || !tableType) return state

            return state
                .setIn([id, tableType, 'lowerBound'], lowerBound)
                .setIn([id, tableType, 'upperBound'], upperBound)
        }
        case FINANCE_TABLE_SET_YEARS: {
            const id = _.get(action, 'data.id', null)
            const tableType = _.get(action, 'data.tableType', null)
            const compareYear = _.get(action, 'data.compareYear', null)
            const sampleYear = _.get(action, 'data.sampleYear', null)

            if (!id || !tableType) return state

            return state
                .setIn([id, tableType, 'compareYear'], compareYear)
                .setIn([id, tableType, 'sampleYear'], sampleYear)
        }
        case FINANCE_TABLE_CHANGE_YEAR_BOUNDS: {
            const id = _.get(action, 'data.id', null)
            const tableType = _.get(action, 'data.tableType', null)
            const shiftLeft = _.get(action, 'data.shiftLeft')
            const dataLength = _.get(action, 'data.dataLength', null)
            const lowerBound = state.getIn([id, tableType, 'lowerBound'])
            const upperBound = state.getIn([id, tableType, 'upperBound'])

            if (!id || !tableType) return state

            if (shiftLeft) {
                if (upperBound === dataLength) return state

                return state
                    .setIn([id, tableType, 'lowerBound'], lowerBound + 1)
                    .setIn([id, tableType, 'upperBound'], upperBound + 1)
            }

            if (lowerBound <= 0) return state

            return state
                .setIn([id, tableType, 'lowerBound'], lowerBound - 1)
                .setIn([id, tableType, 'upperBound'], upperBound - 1)
        }
        case FINANCE_TABLE_CHANGE_COMPARE_YEAR: {
            const id = _.get(action, 'data.id', null)
            const tableType = _.get(action, 'data.tableType', null)
            const newYear = _.get(action, 'data.newYear', null)

            if (!id || !tableType) return state

            return state.setIn([id, tableType, 'compareYear'], newYear)
        }
        case FINANCE_TABLE_CHANGE_SAMPLE_YEAR: {
            const id = _.get(action, 'data.id', null)
            const tableType = _.get(action, 'data.tableType', null)
            const newYear = _.get(action, 'data.newYear', null)

            if (!id || !tableType) return state

            return state.setIn([id, tableType, 'sampleYear'], newYear)
        }
        case FINANCE_TABLE_ADD_OPEN_ROW: {
            const id = _.get(action, 'data.id', null)
            const tableType = _.get(action, 'data.tableType', null)
            const rowId = _.get(action, 'data.rowId', null)
            const openRows = _.get(action, 'data.openRows', [])

            if (!id || !tableType) return state

            const newOpenRows = [...openRows, rowId]

            return state.setIn([id, tableType, 'openRows'], newOpenRows)
        }
        case FINANCE_TABLE_REMOVE_OPEN_ROWS: {
            const id = _.get(action, 'data.id', null)
            const tableType = _.get(action, 'data.tableType', null)
            const rowIds = _.get(action, 'data.rowIds', null)
            const openRows = _.get(action, 'data.openRows', [])

            if (!id || !tableType) return state

            const newOpenRows = _.filter(openRows, (x) => _.indexOf(rowIds, x) < 0)

            return state.setIn([id, tableType, 'openRows'], newOpenRows)
        }
        case FINANCE_TABLE_SET_OPEN_ROWS: {
            const id = _.get(action, 'data.id', null)
            const tableType = _.get(action, 'data.tableType', null)
            const newOpenRows = _.get(action, 'data.newOpenRows', [])

            if (!id || !tableType) return state

            return state.setIn([id, tableType, 'openRows'], newOpenRows)
        }
        case CLOSE_REPORT_BY_ID: {
            const id = _.get(action, 'data.id', null)

            if (!id) return state

            return state.remove(id)
        }
        default:
            return state
    }
}
